document.addEventListener('DOMContentLoaded', function () {
	function sliderOnMob(swiper) {
		const sections = document.querySelectorAll('.screen-slide:has(.vertical_slider_on_mobile)');
		if (sections) {
			sections.forEach(section => {
				// next section
				const nextSection = section.nextElementSibling;
				const wrap = section.querySelectorAll('.vertical_slider_on_mobile');
				// slides is all children of wrap
				const slides = wrap ? Array.from(wrap).map(w => Array.from(w.children)).flat() : null;
				if (slides) {
					slides.forEach(slide => {
						const newSection = document.createElement('div');
						const container = document.createElement('div');
						const hc = document.createElement('span');
						container.className = 'dual-cards-v3 dual-cards-v3--center';
						newSection.className = 'swiper-slide screen-slide';
						hc.className = 'new-screen header-black';
						newSection.appendChild(hc);
						container.appendChild(slide);
						newSection.appendChild(container);
						nextSection.parentNode.insertBefore(newSection, nextSection);
					})
					const otherContent = section.querySelectorAll('.wrap');
					if (otherContent) {
						if (otherContent.length <= 0) {
							section.parentNode.removeChild(section);
						}
					}
				}
				swiper.update();
			})
		}
	}



	setHeaderHeightVariable();
	setAnnouncementHeightVariable();

	const main = document.querySelector('main');

	if (main && main.querySelector('.new-screen')) {
		const swiperContainer = document.createElement('div');
		swiperContainer.className = 'swiper mySwiper';

		const swiperWrapper = document.createElement('div');
		swiperWrapper.className = 'swiper-wrapper';
		swiperContainer.appendChild(swiperWrapper);

		const children = Array.from(main.children);
		let currentSlide = null;

		children.forEach((el) => {
			if (el.querySelector('.new-screen')) {
				currentSlide = document.createElement('div');
				currentSlide.className = 'swiper-slide screen-slide';
				swiperWrapper.appendChild(currentSlide);
			}

			if (currentSlide) {
				currentSlide.appendChild(el);
			}
		});

		const footer = document.querySelector('footer');
		if (footer) {
			const footerSlide = document.createElement('div');
			footerSlide.className = 'swiper-slide b-slide';
			footerSlide.appendChild(footer);
			swiperWrapper.appendChild(footerSlide);
		}

		main.appendChild(swiperContainer);

		let lastScrollTime = 0;
		let accumulatedDelta = 0;
		let scrollTimeout = null;

		const swiper = new Swiper(".mySwiper", {
			direction: "vertical",
			slidesPerView: "auto",
			mousewheel: {
				enabled: true,
				releaseOnEdges: false,
				thresholdDelta: 10,
				thresholdTime: 300,
				forceToAxis: true,
				sensitivity: 1,
			},
			speed: 700,
			effect: "creative",
			creativeEffect: {
				prev: { translate: [0, "-20%", -1] },
				next: { translate: [0, "100%", 0] },
			},
			on: {
				beforeWheel: function (e) {
					const now = performance.now();
					const delta = Math.abs(e.deltaY);

					if (this.animating) {
						e.preventDefault();
						return;
					}

					accumulatedDelta += delta;

					clearTimeout(scrollTimeout);
					scrollTimeout = setTimeout(() => {
						accumulatedDelta = 0;
					}, 150);

					// time based blocking (prevents too fast switching)
					if (now - lastScrollTime < 500) {
						e.preventDefault();
						return;
					}

					// if accumulated delta is too small, wait for more input
					if (accumulatedDelta < 15) {
						e.preventDefault();
						return;
					}

					lastScrollTime = now;
					accumulatedDelta = 0;
				},
				slideChange: function () {
					lastScrollTime = 0;
					accumulatedDelta = 0;
					const headerColorDetect = this.slides[this.activeIndex].querySelector('.new-screen');
					console.log(headerColorDetect);
					if (headerColorDetect) {
						if (headerColorDetect.classList.contains('header-white')) {
							document.documentElement.classList.add('header-white');
						} else {
							document.documentElement.classList.remove('header-white');
						}
					}
					// window width match max-width 768px
					if (window.matchMedia("(max-width: 768px)").matches) {
						const announcementBar = document.querySelector('.section-announcement-bar');
						const header = document.querySelector('header.header-main');
						const headerHeight = header ? header.offsetHeight : 0;
						if (announcementBar) {
							if (this.activeIndex !== 0) {
								announcementBar.style.height = '0px';
								document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
								document.documentElement.style.setProperty('--announcement-height', '0px');
							} else {
								announcementBar.style.height = announcementBar.scrollHeight + 'px';
								document.documentElement.style.setProperty('--header-height', `${headerHeight + announcementBar.scrollHeight}px`);
								document.documentElement.style.setProperty('--announcement-height', `${announcementBar.scrollHeight}px`);
							}
						}
					}

					// Mute all videos when changing slides
					if (window.imageBannerVideos && window.imageBannerVideos.size > 0) {
						window.imageBannerVideos.forEach(videoData => {
							if (!videoData.video.muted) {
								videoData.video.muted = true;
								videoData.muteBtn.classList.remove('unmute');
								videoData.muteBtn.classList.add('mute');
								videoData.video.setAttribute('muted', '');
							}
						});
					}
				},
				init: function () {
					const headerColorDetect = this.slides[this.activeIndex].querySelector('.new-screen');
					if (headerColorDetect) {
						if (headerColorDetect.classList.contains('header-white')) {
							document.documentElement.classList.add('header-white');
						} else {
							document.documentElement.classList.remove('header-white');
						}
					}
				}
			}
		});

		if (window.matchMedia("(max-width: 768px)").matches) {
			sliderOnMob(swiper);
		}
	}
});

// set css variable for header + .section-announcement-bar height
function setHeaderHeightVariable() {
	const header = document.querySelector('header.header-main');
	const announcementBar = document.querySelector('.section-announcement-bar');
	let totalHeight = 0;

	if (header) {
		totalHeight += header.offsetHeight;
	}

	if (announcementBar) {
		totalHeight += announcementBar.offsetHeight;
	}

	document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
	document.documentElement.classList.add('visible');

}
window.addEventListener('resize', setHeaderHeightVariable);

// set css variable for header + .section-announcement-bar height
function setAnnouncementHeightVariable() {
	const announcementBar = document.querySelector('.section-announcement-bar');
	let totalHeight = 0;

	if (announcementBar) {
		totalHeight += announcementBar.offsetHeight;
	}

	document.documentElement.style.setProperty('--announcement-height', `${totalHeight}px`);
	document.documentElement.classList.add('visible');

}
window.addEventListener('resize', setAnnouncementHeightVariable);
